import { useEffect, useState } from 'react'
import {
  LEO_SHARED_UPDATED,
  addLeoListItem,
  addLeoMessage,
  addLeoShoppingItem,
  addLeoTask,
  addLeoUpdate,
  loadLeoSharedDemo,
  type LeoSharedDemoState,
} from '../lib/leoSharedDemo'

const TEAM = ['Casey Morgan', 'Mia Roberts', 'Jordan Blake', 'Olivia Chen']

export function LeoLillianSharedPlanner() {
  const [state, setState] = useState<LeoSharedDemoState>(() => loadLeoSharedDemo())
  const [shopping, setShopping] = useState('')
  const [task, setTask] = useState('')
  const [listName, setListName] = useState('Community outing')
  const [listItem, setListItem] = useState('')
  const [update, setUpdate] = useState('')
  const [message, setMessage] = useState('')
  const [recipient, setRecipient] = useState('Casey Morgan')

  useEffect(() => {
    const refresh = () => setState(loadLeoSharedDemo())
    window.addEventListener(LEO_SHARED_UPDATED, refresh)
    return () => window.removeEventListener(LEO_SHARED_UPDATED, refresh)
  }, [])

  const act = (fn: () => void, clear: () => void) => { fn(); clear(); setState(loadLeoSharedDemo()) }

  return (
    <section className="mt-4 rounded-3xl bg-white p-5 shadow-card">
      <div><p className="text-xs font-black uppercase tracking-wide text-violet-600">Lillian’s shared planning</p><h2 className="mt-1 text-lg font-black text-slate-900">Send work and information to Casey</h2><p className="mt-2 text-xs font-semibold text-slate-500">Anything added here appears in Casey’s Leo Today view using the same shared demo data.</p></div>

      <div className="mt-4 grid gap-4">
        <div className="rounded-2xl bg-amber-50 p-4">
          <p className="text-sm font-black text-slate-900">🛒 Shopping list</p>
          <div className="mt-3 flex gap-2"><input className="input flex-1" value={shopping} onChange={(e)=>setShopping(e.target.value)} placeholder="Add shopping item"/><button onClick={()=>act(()=>addLeoShoppingItem(shopping),()=>setShopping(''))} className="rounded-xl bg-amber-500 px-3 text-xs font-black text-white">Add</button></div>
          <div className="mt-3 flex flex-wrap gap-2">{state.shopping.slice(0,4).map((item)=><span key={item.id} className="rounded-full bg-white px-3 py-2 text-xs font-bold text-slate-600">{item.done?'✓ ':''}{item.text}</span>)}</div>
        </div>

        <div className="rounded-2xl bg-lime-50 p-4">
          <p className="text-sm font-black text-slate-900">✅ Assign task to Casey</p>
          <div className="mt-3 flex gap-2"><input className="input flex-1" value={task} onChange={(e)=>setTask(e.target.value)} placeholder="Task for Casey"/><button onClick={()=>act(()=>addLeoTask(task),()=>setTask(''))} className="rounded-xl bg-lime-600 px-3 text-xs font-black text-white">Assign</button></div>
          <div className="mt-3 grid gap-2">{state.tasks.slice(0,3).map((item)=><div key={item.id} className="rounded-xl bg-white p-3 text-xs"><p className="font-black text-slate-800">{item.done?'✓ ':''}{item.title}</p><p className="mt-1 font-semibold text-slate-400">Assigned to Casey · by Lillian</p></div>)}</div>
        </div>

        <div className="rounded-2xl bg-sky-50 p-4">
          <p className="text-sm font-black text-slate-900">📋 Lists</p>
          <div className="mt-3 grid grid-cols-2 gap-2"><input className="input" value={listName} onChange={(e)=>setListName(e.target.value)} placeholder="List name"/><input className="input" value={listItem} onChange={(e)=>setListItem(e.target.value)} placeholder="List item"/></div>
          <button onClick={()=>act(()=>addLeoListItem(listName,listItem),()=>setListItem(''))} className="mt-2 w-full rounded-xl bg-sky-600 py-2 text-xs font-black text-white">Add to list</button>
          <div className="mt-3 grid gap-2">{state.lists.slice(0,4).map((item)=><div key={item.id} className="rounded-xl bg-white p-3 text-xs"><p className="font-black text-slate-800">{item.list}</p><p className="mt-1 text-slate-600">{item.done?'✓ ':''}{item.text}</p></div>)}</div>
        </div>

        <div className="rounded-2xl bg-violet-50 p-4">
          <p className="text-sm font-black text-slate-900">📣 Add team update</p>
          <textarea className="input mt-3 min-h-20" value={update} onChange={(e)=>setUpdate(e.target.value)} placeholder="Write an update for Leo’s team…" />
          <button onClick={()=>act(()=>addLeoUpdate(update),()=>setUpdate(''))} className="mt-2 w-full rounded-xl bg-violet-600 py-2 text-xs font-black text-white">Post update</button>
          {state.updates[0] && <div className="mt-3 rounded-xl bg-white p-3 text-xs text-slate-600"><strong>{state.updates[0].from}:</strong> {state.updates[0].text}</div>}
        </div>

        <div className="rounded-2xl bg-rose-50 p-4">
          <p className="text-sm font-black text-slate-900">💬 Message Leo’s team</p>
          <select className="input mt-3" value={recipient} onChange={(e)=>setRecipient(e.target.value)}>{TEAM.map((name)=><option key={name}>{name}</option>)}</select>
          <textarea className="input mt-2 min-h-20" value={message} onChange={(e)=>setMessage(e.target.value)} placeholder={`Message ${recipient}…`} />
          <button onClick={()=>act(()=>addLeoMessage(recipient,message),()=>setMessage(''))} className="mt-2 w-full rounded-xl bg-rose-600 py-2 text-xs font-black text-white">Send message</button>
          <div className="mt-3 grid gap-2">{state.messages.slice(0,3).map((item)=><div key={item.id} className="rounded-xl bg-white p-3 text-xs"><p className="font-black text-slate-700">{item.from} → {item.to}</p><p className="mt-1 text-slate-600">{item.text}</p></div>)}</div>
        </div>
      </div>
    </section>
  )
}

